import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

import * as Company from './Company';
import * as User from './User';

export type V = {
  '@id': string;
  '@type': 'TicketReportApproval';
  id: string;
  company: Company.BaseView;
  approvedBy: User.BaseView | null;
  approvedAt: string;
  month: string | null;
  week: string | null;
  isTimeLoggedVisible: boolean;
};

export type V_Client = {
  '@id': string;
  '@type': 'TicketReportApproval';
  id: string;
  month: string | null;
  week: string | null;
};

export type W = {
  company: string;
  month: string | null;
  week: string | null;
  isTimeLoggedVisible: boolean;
};

export function useReadCollectionCompanySub(
  companyId: string,
  options?: ReadConfig
) {
  return useApiRead<HydraCollection<V_Client>>(
    `/companies/${companyId}/ticket-report-approvals`,
    options
  );
}
